export default __webpack_public_path__ + "40165d68fb541a4d638014ef49265575.svg";